import { BlogPostContent } from "@/types/blog";
import { intro } from "./sections/intro";
import { innereReife } from "./sections/innere-reife";
import { psychologischeSicherheit } from "./sections/psychologische-sicherheit";
import { beziehung } from "./sections/beziehung";
import { sinn } from "./sections/sinn";
import { entwicklung } from "./sections/entwicklung";
import { entscheidungen } from "./sections/entscheidungen";
import { technologie } from "./sections/technologie";
import { selbstfuersorge } from "./sections/selbstfuersorge";
import { fazit } from "./sections/fazit";
import { quellen } from "./sections/quellen";
import { anmerkung } from "./sections/anmerkung";

export const content: BlogPostContent = {
  sections: [
    intro,
    innereReife,
    psychologischeSicherheit,
    beziehung,
    sinn,
    entwicklung,
    entscheidungen,
    technologie,
    selbstfuersorge,
    fazit,
    quellen,
    anmerkung
  ]
};
